import {
  Authorisation,
  Place,
  CustomsOfficeOfTransitDeclared,
  LocationOfGoods,
  Consignee,
  Consignor,
  Carrier,
  TransportEquipment,
  ActiveBorderTransportMeans, PreviousDocument,
} from 'shared/ncts/common/types'
import { NctsCountry } from '../../../../../../../config'
import { GetDeclarationFormFieldRequirementContext } from '../../types'
import { ServerValidationResult } from '../../../../../models/types'

export type FieldRequirementResolverContext = {
  country?: string | null
  phase: 'p5' | 'p6'
  isOptIn: boolean
  security: string
  additionalDeclarationType: string
  bindingItinerary: string
  borderModeOfTransport: string
  inlandModeOfTransport?: string
  containerIndicator?: string
  specificCircumstanceIndicator?: string
  entryIndicator?: string
  departureCustomsOffice: string
  placeOfLoading: Place
  placeOfUnloading: Place
  reducedDatasetIndicator?: string
  authorisations: Authorisation[]
  transitCustomsOffices: CustomsOfficeOfTransitDeclared[]
  transitCustomsOffice?: CustomsOfficeOfTransitDeclared
  locationOfGoods?: LocationOfGoods
  carrier?: Carrier
  consignor?: Consignor
  consignee?: Consignee
  transportEquipments?: TransportEquipment[]
  transportEquipment?: TransportEquipment
  activeBorderTransportMeansItem?: ActiveBorderTransportMeans
  previousDocument?: PreviousDocument
  serverValidationResult?: ServerValidationResult
}

export function toFieldRequirementResolverContext(path: string, {
  country,
  phase,
  isOptIn,
  security,
  additionalDeclarationType,
  specificCircumstanceIndicator,
  valuesMap,
  serverValidationResult,
}: GetDeclarationFormFieldRequirementContext): FieldRequirementResolverContext {
  const authorisations = valuesMap.authorisations as Authorisation[] | undefined
  const transitCustomsOffices = valuesMap.transitCustomsOffices as CustomsOfficeOfTransitDeclared[] | undefined
  const transportEquipments = valuesMap.transportEquipment as TransportEquipment[] | undefined
  let transitCustomsOffice
  let transportEquipment
  let previousDocument
  let activeBorderTransportMeansItem

  if (path.startsWith('transitCustomsOffices.') && path.endsWith('.arrivalDateAndTime')) {
    const parts = path.split('.')
    const index = parts[1]
    const valueKey = `transitCustomsOffices.${index}`
    transitCustomsOffice = valuesMap[valueKey] as CustomsOfficeOfTransitDeclared | undefined
  }

  if (path.startsWith('transportEquipment.')) {
    const parts = path.split('.')
    const index = parts[1]
    const valueKey = `transportEquipment.${index}`
    transportEquipment = valuesMap[valueKey] as TransportEquipment | undefined
  }

  if (path.startsWith('previousDocument.')) {
    const parts = path.split('.')
    const index = parts[1]
    const valueKey = `previousDocument.${index}`
    previousDocument = valuesMap[valueKey] as PreviousDocument | undefined
  }

  if (path.startsWith('activeBorderTransportMeans.')) {
    const parts = path.split('.')
    const index = parts[1]
    const valueKey = `activeBorderTransportMeans.${index}`
    activeBorderTransportMeansItem = valuesMap[valueKey] as ActiveBorderTransportMeans | undefined
  }

  return {
    country: country ?? '' as NctsCountry,
    phase,
    isOptIn,
    security,
    borderModeOfTransport: valuesMap.borderModeOfTransport as string ?? '',
    bindingItinerary: valuesMap.bindingItinerary as string ?? null,
    containerIndicator: valuesMap.containerIndicator as string ?? null,
    departureCustomsOffice: valuesMap.departureCustomsOffice as string ?? '',
    specificCircumstanceIndicator,
    entryIndicator: valuesMap.entryIndicator as string ?? null,
    reducedDatasetIndicator: valuesMap.reducedDatasetIndicator as string ?? null,
    additionalDeclarationType,
    placeOfUnloading: valuesMap.placeOfUnloading as Place,
    placeOfLoading: valuesMap.placeOfUnloading as Place,
    authorisations: authorisations?.filter((a): a is Authorisation => a !== undefined) ?? [],
    transitCustomsOffices: transitCustomsOffices?.filter((a): a is CustomsOfficeOfTransitDeclared => a !== undefined) ?? [],
    transitCustomsOffice,
    locationOfGoods: valuesMap.locationOfGoods as LocationOfGoods,
    carrier: valuesMap.carrier as Carrier,
    consignor: valuesMap.consignor as Consignor,
    consignee: valuesMap.consignee as Consignee,
    transportEquipments: transportEquipments?.filter((a): a is TransportEquipment => a !== undefined) ?? [],
    transportEquipment,
    previousDocument,
    activeBorderTransportMeansItem,
    serverValidationResult,
  }
}
